/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S12_Li1_DescInputs */

const tr_iade_iptal_s12_li1_desc = /** @type {(inputs: Iade_Iptal_S12_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketilmiş krediler iadeye konu edilemez; iade yalnızca kullanılmamış ön ödemeli krediler için pro-rata yapılır.`)
};

const en_iade_iptal_s12_li1_desc = /** @type {(inputs: Iade_Iptal_S12_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumed credits cannot be subject to a refund; a pro-rata refund is made only for unused prepaid credits.`)
};

const de_iade_iptal_s12_li1_desc = /** @type {(inputs: Iade_Iptal_S12_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbrauchte Credits können nicht Gegenstand einer Erstattung sein; erstattet wird anteilig nur für nicht genutzte, im Voraus bezahlte Credits.`)
};

const ru_iade_iptal_s12_li1_desc = /** @type {(inputs: Iade_Iptal_S12_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Израсходованные кредиты не могут являться предметом возврата; пропорциональный возврат производится только за неиспользованные предоплаченные кредиты.`)
};

/**
* | output |
* | --- |
* | "Consumed credits cannot be subject to a refund; a pro-rata refund is made only for unused prepaid credits." |
*
* @param {Iade_Iptal_S12_Li1_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s12_li1_desc = /** @type {((inputs?: Iade_Iptal_S12_Li1_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S12_Li1_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s12_li1_desc(inputs)
	if (locale === "de") return de_iade_iptal_s12_li1_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s12_li1_desc(inputs)
	return tr_iade_iptal_s12_li1_desc(inputs)
});